import PropTypes from 'prop-types'
import React from 'react'
import { Helmet } from 'react-helmet'
import './layout.css'

const Layout = ({ children }) => (
  <main>
    <Helmet>
      <meta charSet="utf-8" />
      <title>AI MONOLOGER</title>
      <link rel="canonical" href="http://futurologi.org/ai-monologer" />
      <meta
        name="description"
        content="Center for Militant Futurologi inviterer alle med håb og drømme om fremtiden til at deltage i et målrettet angreb på den kollektive fantasi med utopiske og radikale visioner for kunstig intelligens."
      />
      <html lang="en" />
      <meta
        property="og:image"
        content="http://futurologi.org/ai-monologer/ai-monologer.jpg"
      />
    </Helmet>
    {children}
  </main>
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
